import React from 'react'
import { DateRangePicker } from 'react-date-range'
import { Link, useNavigate } from 'react-router-dom'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import moment from 'moment'
import {
  $DCprimaryColor,
  $secondaryColor,
  DcBreadcrumbs,
  DcDateRangePicker,
  DcFlexBox,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'
import queryString from 'query-string'
import styled from 'styled-components'

import { getReconcileSummary } from 'utils/api-routes.util'

const PaymentCourierWise = () => {
  const [tableLoading, setTableLoading] = React.useState(false)
  const [courierList, setCourierList] = React.useState([])
  const [showDateModal, setshowDateModal] = React.useState(false)
  const navigate = useNavigate()
  const p = queryString.parse(window.location.search)

  const [filters, setFilters] = React.useState<any>({
    page: 0,
    start_date:
      moment(p.start_date).format('YYYY-MM-DD') ||
      moment().startOf('month').format('YYYY-MM-DD'),
    end_date:
      moment(p.end_date).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD'),
  })
  const [dateFilter, setDateFilter] = React.useState({
    start_date: null,
    end_date: null,
  })

  const breadcrumbs = [
    {
      name: 'Courier Reconciliation',
      active: true,
    },
  ]

  React.useEffect(() => {
    navigate({
      pathname: '/payments/payments-courier-wise',
      search: queryString.stringify(filters),
    })
    getAllReconcileSummary()
  }, [filters])
  const getAllReconcileSummary = () => {
    setTableLoading(true)
    getReconcileSummary(filters).subscribe((res: any) => {
      setCourierList(res.response.data)
      setTableLoading(false)
    })
  }

  const columns = [
    {
      dataKey: 'courier_name',
      name: 'Courier Name',
      sortable: true,
      selector: (row) => row.courier_name || '--',
    },
    {
      dataKey: 'reconciled',
      name: 'Reconciled',
      sortable: true,
      selector: (row) => (
        <TableLink
          to={`/payments/courier-wise-detail?courier_id=${row['courier_id']}&reconcile_status=reconciled&start_date=${filters.start_date}&end_date=${filters.end_date}`}
        >
          {row.reconciled}
        </TableLink>
      ),
    },
    {
      dataKey: 'total_discrepant',
      name: 'Discrepant',
      sortable: true,
      selector: (row) => (
        <TableLink
          to={`/payments/courier-wise-detail?courier_id=${row['courier_id']}&reconcile_status=discrepant&start_date=${filters.start_date}&end_date=${filters.end_date}`}
        >
          {row.total_discrepant}
        </TableLink>
      ),
    },
    {
      dataKey: 'inProgress',
      name: 'In Progress',
      sortable: true,
      selector: (row) => (
        <TableLink
          to={`/payments/courier-wise-detail?courier_id=${row['courier_id']}&reconcile_status=inprogress&start_date=${filters.start_date}&end_date=${filters.end_date}`}
        >
          {row.inProgress}
        </TableLink>
      ),
    },
    {
      dataKey: 'total',
      name: 'Total',
      sortable: true,
      selector: (row) => (
        <TableLink
          to={`/payments/courier-wise-detail?courier_id=${row['courier_id']}&reconcile_status=all&start_date=${filters.start_date}&end_date=${filters.end_date}`}
        >
          {row.total}
        </TableLink>
      ),
    },
  ]

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              height="auto"
              padding=" 5px 20px"
            >
              <DcDateRangePicker
                month={2}
                size="sm"
                ranges={{
                  start_date: new Date(
                    dateFilter.start_date == null
                      ? filters.start_date
                      : dateFilter.start_date,
                  ),
                  end_date: new Date(
                    dateFilter.end_date == null
                      ? filters.end_date
                      : dateFilter.end_date,
                  ),
                }}
                onApply={() => {
                  setFilters({
                    ...filters,
                    start_date: moment(dateFilter.start_date).format(
                      'YYYY-MM-DD',
                    ),
                    end_date: moment(dateFilter.end_date).format('YYYY-MM-DD'),
                  })
                }}
                onChange={(e) => {
                  setDateFilter({
                    ...dateFilter,
                    start_date: e.range1.startDate,

                    end_date: e.range1.endDate,
                  })
                }}
              />
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={courierList}
              isSearchable={false}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>

      {showDateModal && (
        <PixelModal
          title={''}
          size={{
            width: '950px !important',
            maxWidth: '100% !important',
          }}
          handleClose={() => setshowDateModal(false)}
          show={showDateModal}
        >
          <DatepickerContainer>
            <DateRangePicker
              rangeColors={[$DCprimaryColor]}
              onChange={(item) => {
                if (
                  moment(item.selection.startDate).format('YYYY-MM-DD') !==
                  moment(item.selection.endDate).format('YYYY-MM-DD')
                ) {
                  setshowDateModal(false)
                } else if (
                  item.selection.startDate === '' &&
                  item.selection.endDate === ''
                ) {
                  setshowDateModal(false)
                }
                setFilters({
                  start_date: moment(item.selection.startDate).format(
                    'YYYY-MM-DD',
                  ),
                  end_date: moment(item.selection.endDate).format('YYYY-MM-DD'),
                })
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={[
                {
                  startDate: new Date(filters.start_date),
                  endDate: new Date(filters.end_date),
                  key: 'selection',
                },
              ]}
              direction="horizontal"
            />
          </DatepickerContainer>
        </PixelModal>
      )}
    </>
  )
}

const TableLink = styled(Link)`
  color: ${$DCprimaryColor};
  text-decoration: none;
  &:hover {
    color: ${$secondaryColor};
  }
`

const DatepickerContainer = styled.div`
  overflow: auto;
`

export default PaymentCourierWise
